import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import { defaultCountries } from 'react-international-phone';

// Corrige los formatos de Argentina en react-international-phone:
// los patrones /^(2|3|4|5)/ y /^9/ tenían 9 y 10 dígitos respectivamente,
// pero los números argentinos necesitan 10 (fijo) y 11 (móvil con prefijo 9).
export const phoneCountries = defaultCountries.map((country) => {
  if (country[1] === 'ar') {
    return [
      country[0],
      country[1],
      country[2],
      {
        default: '(..) .... ....',
        '/^11/': '(..) .... ....',
        '/^15/': '(..) ... ....',
        '/^911/': '. (..) .... ....', // BA móvil: 9 + 11 + XXXXXXXX
        '/^9/': '. (...) ... ....', // otro móvil: 9 + AAA + XXXXXXX
        '/^(2|3|4|5)/': '(...) ... ....', // fijo fuera de BA: AAA + XXXXXXX
      },
      country[4],
    ] as typeof country;
  }
  return country;
});

export function isValidPhone(phone: string): boolean {
  try {
    return isValidPhoneNumber(phone);
  } catch {
    return false;
  }
}

// Normaliza a E.164. Maneja el prefijo móvil "9" de Argentina:
// +54 223 540 6392 y +54 9 223 540 6392 → mismo resultado E.164.
export function normalizePhone(phone: string): string | null {
  try {
    const parsed = parsePhoneNumber(phone);
    if (!parsed?.isValid()) return null;
    return parsed.format('E.164');
  } catch {
    return null;
  }
}
